export default __webpack_public_path__ + "static/media/EcoV2.b28ddadd.png";